import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../../environments/environment';
import {AuthStateService} from "./auth-state.service";

export function KeycloakInit(keycloak: KeycloakService, authState: AuthStateService) {
    return () =>
        keycloak.init({
            config: {
                url: environment.KeycloakUrl,
                realm: environment.KeycloakRealm,
                clientId: environment.KeycloakClientId
            },
            // https://stackoverflow.com/questions/72019588/how-to-avoid-timeout-when-waiting-for-3rd-party-check-iframe-message-with-keyc
            initOptions: {
                onLoad: 'check-sso',
                pkceMethod: 'S256',
                checkLoginIframe: false,
                silentCheckSsoRedirectUri:
                    window.location.origin + '/assets/silent-check-sso.html'
            },
            enableBearerInterceptor: true,
            bearerExcludedUrls: [
                '/assets'
            ]
        })
            .then(() => authState.markReady())
        // .then(isLogged => {
        //     if (isLogged) {
        //         return keycloak.getToken();
        //     }
        //     return null;
        // })
        // .then(token => {
        //     if (token) {
        //         // loginService.token.next('Bearer ' + token);
        //     }
        // });
        ;
}
